export default {
  'AI Face Animator': 'Animator Wajah AI',
  'Create incredible facial expressions with brainwashing music, find the magic for fun.': 'Ciptakan ekspresi wajah yang luar biasa dengan musik, temukan keajaiban yang seru.',
  'Upload a photo': 'Unggah foto',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.': 'Catatan: tolong pastikan wajah dalam foto yang Anda pilih menghadap lensa, jika tidak maka tidak akan berhasil diproses.',
  'Uploaded successfully!': 'Berhasil diunggah!',
  'Please select a template below': 'Silahkan pilih template di bawah ini',
  'Choose a GIF': 'Pilih GIF',
  'Use this template': 'Gunakan template ini',
  'Verify successfully! You will': 'Verifikasi berhasil! Anda akan segera menerima video di {{email}}.',
  'You will': 'Anda akan segera menerima video di {{email}}.',
  'What you should expect to happen next': 'Apa yang akan terjadi selanjutnya:',
  'We will process your photo into a dynamic video.': 'Kami akan memproses foto Anda menjadi video dinamis.',
  'After processing, we will send the video to your email.': 'Setelah diproses, video akan kami kirimkan ke email Anda.',
  'You can check the video in your email.': 'Anda dapat memeriksa video di email Anda.',
  'Your video will be delivered via email': 'Video Anda akan dikirim melalui email',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.': 'Diperlukan waktu 20-30 menit untuk membuat video dinamis, silahkan tunggu. Untuk melindungi privasi Anda, gambar yang diunggah akan otomatis dihapus setelah pemrosesan selesai.',
  'Your Email': 'Email Anda',
  'Last Name': 'Nama Depan',
  'First Name': 'Nama Belakang',
  'Go back': 'Kembali',
  'Invalid email address':'Alamat email tidak valid',
  'Enter verification code':'Masukkan kode verifikasi',
  'Enter the verification code that we sent to': 'Masukkan kode verifikasi yang kami kirim ke {{email}}.',
  'Resend': 'Kirim Ulang',
  'Verification code': 'Kode verifikasi',
  'Resend after': 'Kirim ulang setelah {{num}}d',
  'The verification code is invalid. You can request a new one.': 'Kode verifikasi tidak valid. Anda dapat meminta yang baru.',
  'Synthesize Video': 'Membuat Video',
  'Too many attempts, please try again later.': 'Terlalu banyak percobaan, tolong coba lagi nanti.',
}